<template>
    <div :class="getClasses()">
        <slot></slot>
    </div>
</template>

<script>
export default {
    name: "GridCol",
    props: {
        xs: {
            type: [Number, String],
            required: false,
        },
        sm: {
            type: [Number, String],
            required: false,
        },
        md: {
            type: [Number, String],
            required: false,
        },
        lg: {
            type: [Number, String],
            required: false,
        },
        xl: {
            type: [Number, String],
            required: false,
        },
        size: {
            type: [Number, String],
            required: false,
        },
        option: {
            type: String,
            default: "md",
        }
    },
    data() {
        return {
            classes: {},
        }
    },
    methods: {
        getClasses() {
            this.classes[`col-${this.xs}`] = this.xs;
            this.classes[`col-sm-${this.sm}`] = this.sm;
            this.classes[`col-md-${this.md}`] = this.md;
            this.classes[`col-lg-${this.lg}`] = this.lg;
            this.classes[`col-xl-${this.xl}`] = this.xl;

            if (!this.xs && !this.sm && !this.md && !this.lg && !this.xl) {
                this.classes['col-md' + this.size] = true;
            }

            return this.classes;
        }
    },
}
</script>